import * as React from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Discount from '../../../svg/DicountIcon'
import {IconButton, Stack} from '@mui/material'
import Label from '../../customTable/Label'
import FixedNumber from '../../customTable/FixedNumber'

export default function BasicMenu({editItem}: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Discount />
      </IconButton>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Stack gap='10px' p='15px'>
          {' '}
          <Stack
            sx={{fontSize: '10px', color: '#B5B5C3'}}
            alignItems={'center'}
            direction={'row'}
            gap='5px'
          >
            {' '}
            <Label fs='10px' color={'#B5B5C3'} text='productDiscont' />:{' '}
            <FixedNumber
              fs='10px'
              color={'#B5B5C3'}
              num={editItem.unit_price - editItem.unit_sale_price}
            />
          </Stack>{' '}
          <Stack
            sx={{fontSize: '10px', color: '#B5B5C3'}}
            alignItems={'center'}
            direction={'row'}
            gap='5px'
          >
            {' '}
            <Label fs='10px' color={'#B5B5C3'} text='bulkDiscount' /> :{' '}
            <FixedNumber fs='10px' color={'#B5B5C3'} num={editItem.bulk_item_discount} />
          </Stack>
        </Stack>

        {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleClose}>Logout</MenuItem> */}
      </Menu>
    </div>
  )
}
